import { createFileRoute } from "@tanstack/react-router";

import { CHINESE_CALENDAR_COPY, ChineseCalendarView } from "../components/tools/chinese-calendar";
import { faqJsonLd } from "../components/tools/tool-layout";
import { seo } from "../lib/head";

export const Route = createFileRoute("/calendrier-chinois-grossesse")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "Calendrier chinois de grossesse : fille ou garçon ? · Listou",
      description:
        "Le calendrier chinois de grossesse en ligne : âge et mois lunaires calculés pour vous, et le tableau complet. Un jeu pour patienter jusqu'à l'échographie.",
      jsonLd: faqJsonLd(CHINESE_CALENDAR_COPY.faq),
    }),
  component: ChineseCalendarView,
});
